module.exports = __webpack_public_path__ + "static/media/SearchIcon.5533af74.svg";